import { ActivityLogType } from "@core/configs";
import { LocalStorageKey } from "@core/constants";
import { FieldActivityType } from "@core/models/enums";
import moment from "moment";
// @example generateTimeArray(new Date().getHours());
export const generateTimeArray = (currentHour: number, intervalTime: number, segmentNum: number = 4): number[] => {
  if(!intervalTime) intervalTime = 2;
  let result: number[] = [];
  for (let i = 1; i < segmentNum; i++) {
    // Tính giờ trong khoảng 0-23 giờ
    const time = (currentHour + i * intervalTime) % 24;
    // Nếu time < 0, phải cộng thêm 24 để đưa về kiểu 24 giờ
    result.push(time < 0 ? time + 24 : time);
  }
  return result;
}

export const getTimeItembyMaxMin = (config:any, currenttime:any):any[] =>{
  let result: any[] = [];

  if(!config.interval) config.interval = 2;

  for (let i = config.min ; i <= config.max; i= i + config.interval) {
    const date = new Date(currenttime);
    date.setHours(i);
    date.setMinutes(0);
    date.setSeconds(0);
    result.push(date);
  }
  return result;
}
export const getHeaderMaxMin = (config:any, currenttime:any):any[] =>{
  let result: any[] = [];

  if(!config.interval) config.interval = 2;

  for (let i = config.min ; i <= config.max; i= i + config.interval) {
    const date = new Date(currenttime);
    date.setHours(i);
    date.setMinutes(0);
    date.setSeconds(0);
    if(config.interval > 1)
      result.push(date.getHours() + Math.floor(config.interval/2));
    else
      result.push(date.getHours());
  }
  return result;
}
export const getHeaderCurrentTime = (config:any, currenttime:any):any[] => {
  let result: any[] = [];
  if(!config.interval) config.interval = 2;
  if(!config.segmentNum) config.segmentNum = 6;

  for (let i = config.segmentNum ; i >= -1; i--) {
    const date = new Date(currenttime);
    date.setHours(date.getHours() - i*config.interval);
    if(config.showEven && date.getHours() % 2 != 0) date.setHours(date.getHours() - 1);
    else if(config.showEven && date.getHours() % 2 == 0) date.setHours(date.getHours() - 2);
    date.setMinutes(0);
    date.setSeconds(0);
    result.push(date.getHours());
  }
  return result;
}


export const getTimeItembyCurrentTime = (config:any, currenttime:any):any[] => {
  let result: any[] = [];
  if(!config.interval) config.interval = 2;
  if(!config.segmentNum) config.segmentNum = 6;

  for (let i = config.segmentNum ; i >= -1; i--) {
    const date = new Date(currenttime);
    date.setHours(date.getHours() - i*config.interval);
    if(config.showEven && date.getHours() % 2 != 0) date.setHours(date.getHours() - 1);
    else if(config.showEven && date.getHours() % 2 == 0) date.setHours(date.getHours() - 2);
    date.setMinutes(0);
    date.setSeconds(0);
    result.push(date);
  }
  return result;
}

export const getTimeItemby24h = (config:any, currenttime:any):any[] =>{

  return [];
}


export const getTimeItems = (config:any, currenttime:any): any[] => {
  switch(config.type){
    case ActivityLogType.LogMaxMin:
      return getTimeItembyMaxMin(config, currenttime);
      break;
    case ActivityLogType.LogCurrent:
      return getTimeItembyCurrentTime(config, currenttime);
      break;
    case ActivityLogType.Log24h:
      return getTimeItemby24h(config, currenttime);
      break;
    default:
      return getTimeItemby24h(config, currenttime);
      break;
  }
}
export const getHeaderItems = (config:any, currenttime:any): any[] => {
  switch(config.type){
    case ActivityLogType.LogMaxMin:
      return getHeaderMaxMin(config, currenttime);
      break;
    case ActivityLogType.LogCurrent:
      return getHeaderCurrentTime(config, currenttime);
      break;
    case ActivityLogType.Log24h:
      return getTimeItemby24h(config, currenttime);
      break;
    default:
      return getTimeItemby24h(config, currenttime);
      break;
  }
}
export const getActivityLogDataCell = (data:any, timeItem:any, config: any):any => {
  if(!data || data.length == 0) return []
  let dataCell:any = [];
  let startDate = new Date(timeItem);

  let slots = config.interval * 60 / config.timeInterval;

  for (let slot = 0; slot < slots; slot++) {
    //filter data by startDate and EndDate
    let startDate = new Date(timeItem);
    startDate.setMinutes(slot * config.timeInterval);
    startDate.setSeconds(0);
    startDate.setMilliseconds(0);
    let endDate = new Date(timeItem);
    endDate.setMinutes((slot + 1) * config.timeInterval);
    endDate.setSeconds(0);
    endDate.setMilliseconds(0);

    let datafilter = data.filter((cell: any) => {
      let date = new Date(cell.time);
      return (date.getTime() >= startDate.getTime() && date.getTime() < endDate.getTime())
    })
    .sort((cell_1: any, cell_2:any) => {
        return  (new Date(cell_2.time)).getTime() - (new Date(cell_1.time)).getTime()
    })
 

    if (datafilter.length > 0) {

      //Pick the newest item for each unique type
      let latestItems = new Map<number, any>();
      datafilter.forEach((cell: any) => {
        if (!latestItems.has(cell.type)) {
          latestItems.set(cell.type, cell);
        }
      });

      let latestItemsArr = Array.from(latestItems.values())
      
      let itemsSortByType:any[] =[];
      itemsSortByType = latestItemsArr.sort((item_1:any, item_2:any ) =>  item_1.type - item_2.type);


      for(let i = 0; i < itemsSortByType.length; i++) {
        let dataTime :any = {};
        dataTime.column = slot;
        dataTime.item = itemsSortByType[i];
        dataCell.push(dataTime)
      }
    }
  }
  
  return dataCell;
}
export const getFormattedDate = (currentDate: Date, days: number): string => {
    return moment(currentDate).subtract(days, 'days').format('MM/DD');
}
export const sortItemByType = (latestItemsArr: any): any[] => {
  let itemsSort:any[] =[];
  let itemTypeMedicine = latestItemsArr.filter((item:any) => item.type == FieldActivityType.MEDICINE || item.type == FieldActivityType.MEDICINENYUSHO);
  let itemTypeUrinaton = latestItemsArr.filter((item:any) => item.type == FieldActivityType.URINATION);
  let itemTypedefecation = latestItemsArr.filter((item:any) => item.type == FieldActivityType.DEFECATION);
  let itemTypeOthers = latestItemsArr.filter((item:any) => item.type != FieldActivityType.MEDICINE
                                                        && item.type != FieldActivityType.MEDICINENYUSHO 
                                                        && item.type != FieldActivityType.URINATION
                                                        && item.type != FieldActivityType.DEFECATION);

  if (itemTypeMedicine.length > 0) {
    itemsSort = [...itemTypeMedicine];
    if(itemTypeUrinaton.length > 0 && itemTypedefecation.length > 0){
      itemsSort = [...itemsSort, {}];
    }
  } 
  
  if(itemTypeUrinaton.length > 0)
    itemsSort = [...itemsSort, ...itemTypeUrinaton];
  if(itemTypedefecation.length > 0)
    itemsSort = [...itemsSort, ...itemTypedefecation];
  
  if(itemTypeOthers.length > 0)
    itemsSort = [...itemsSort, ...itemTypeOthers];

  return itemsSort;
}

// @example generateTimeArrayFromTo(9,16);
// @from 9 bắt đầu làm việc từ 9h
// @to 16 kết thúc làm việc 17 giờ thì gen tới 16 giờ thôi
export const generateTimeArrayFromTo = (from: number, to: number): number[] => {
    const result: number[] = [];
    // Nếu from <= to thì lặp từ from đến to cách nhau 2 giờ
    if (from <= to) {
      for (let i = from; i <= to; i += 2) {
        result.push(i);
      }
    } else {
      // Nếu from > to thì lặp từ from đến 23 và từ 0 đến to với khoảng cách là 2 giờ
      for (let i = from; i < 24; i += 2) {
        result.push(i);
      }
      for (let i = 0; i <= to; i += 2) {
        result.push(i);
      }
    }
    return result;
}

  // convert thời gian qua số
  export const convertTimeToDecimal = (time: string): number => {
    if (!time) return 0;
    const [hour, minute] = time.split(':').map(Number);
    return hour + minute / 60;
  }

  export const generateUserDashboardHeader = (config: any): number[] => {
    if (!config) return [];

    let result = [];
    const currentHour = new Date().getHours();
    // Adjust currentHour to the nearest even hour if it's odd
    let hour = currentHour % 2 === 0 ? currentHour : currentHour + 1;

    // Loop to generate the hours list based on the interval and max value
    for (let i = 0; i < config.max / config.interval; i++) {
        // Increment hour by the interval, and ensure it wraps around using modulus (%) 
        hour = (hour + config.interval) % config.max;
        result.push(hour);
    }

    return result; 
}

  export const generateTimeSlots = (config: any): number[] => {  
    let result: number[] = [];
    if(!config) return [];
    const currentHour = new Date().getHours();
    // Tính toán giờ bắt đầu (lùi lại (sementNum - 1) * interval)
    let startHour = currentHour - (config.segmentNum - 1) * config.interval;
    // Lặp qua số lượng phần tử và tính từng mốc thời gian
    for (let i = 0; i < config.segmentNum; i++) {
        let time = (startHour + i * config.interval) % 24;
      
        // Đảm bảo giờ không bị âm (trong trường hợp currentHour quá nhỏ)
        result.push(time < 0 ? time + 24 : time);
    }
    return result;
  };

  export const getRedLinePosition = (config: any, headers: any[]): any => {
    if(!headers || headers.length == 0) return 0;
     //
    let currentHour: number = new Date().getHours();
    let currentMinute: number = new Date().getMinutes();
    let percent: number = 100 / (config.interval);
    let percentByMinute = (currentMinute / 60) * percent; 
    let pos = percentByMinute - config.interval;
    let lastItemWidth: number = 0;
    if (!headers.includes(currentHour)) {
      // Nếu giờ hiện tại không nằm trong mảng thì + thêm 50%
      pos = pos + percent;
    }
    if(config?.type == 3) {
      if(config?.marginToTime) {
       // Phần trăm thời gian còn lại
       let remaining: number = 100 - pos;
       // phần trăm của khoảng thời gian margin
       let marginPercent: number = (100 / 60) * config?.marginToTime;
       lastItemWidth = pos + marginPercent;
       if(remaining < marginPercent && lastItemWidth > 0) pos = (pos * 100)/lastItemWidth;
      }
    }
    lastItemWidth = lastItemWidth <= 0 ? pos + 5 : lastItemWidth;
    return { position: pos, lastItemWidth: lastItemWidth/ (config.interval || 1) };
  }